<template>
  <header class="gridx">
    <vs-navbar
      v-model="indexActive"
      :color="topbarColor"
      class="topnavbar"
      text-color="rgba(255,255,255,0.7)"
      active-text-color="rgba(255,255,255,1)"
      style="z-index: 999 !important; position: fixed; top: 0; left: 0; right: 0"
    >
      <!---
      Template logo
      -->
      <div slot="title" class="themelogo">
        <img src="@/assets/images/logo/logo-white.png" alt="Dashboard" />
        <div class="logo-text-container">
          <span class="logo-text" v-if="title">{{ title }}</span>
          <span class="circle"></span>
          <span class="logo-text bold">Web</span>
        </div>
      </div>

      <!--
      <LangSelector />
      -->
      <!---
    Mobile toggle
    -->
      <div slot="title">
        <div class="hiddenDesktop cursor-pointer" @click.stop="activeSidebar">
          <vs-icon icon="menu"></vs-icon>
        </div>
      </div>

      <div
        class="hiddenMobile cursor-pointer"
        @click="fullSidebar"
        v-show="showToggle"
      >
        <vs-icon icon="menu"></vs-icon>
      </div>

      <vs-spacer></vs-spacer>
      <vs-dropdown
        vs-trigger-click
        left
        class="cursor-pointer pr-2 pl-2 ml-1 mr-md-3"
      >
        <a class="text-white-dark user-image d-block" href="#">
          <span class="v-btn__underlay"></span>
          <img src="@/assets/images/users/user-1.jpg" alt="User" />
        </a>

        <vs-dropdown-menu class="user-dd common-dd topbar-dd">
          <div v-for="user in users" :user="user" :key="user.usertitle">
            <div class="d-flex header align-items-center text-white mb-2">
              <h3 class="widget-title">Usuario</h3>

              <div class="user-details">
                <img
                  :src="require('@/assets/images/users' + user.img)"
                  alt="user"
                  class="rounded-circle"
                  width="80"
                />

                <div class="widget-details">
                  <div class="ml-2">
                    <h4 class="mb-0">{{ name || 'INVITADO' }}</h4>
                    <p class="mb-0 flex-row align-items-center">
                      <vs-icon icon="email" class="mr-1"></vs-icon>
                      <span class="email-text">{{ email || 'invitado' }}</span>
                    </p>
                  </div>
                </div>
              </div>

              <div class="user-menu-options">
                <a :href="composedLink" class="user-menu-option">
                  <div class="icon">
                    <img
                      src="@/assets/images/icons/icon-account.png"
                      class="icon-account"
                    />
                  </div>
                  <div class="details">
                    <label class="label">Mi perfil</label>
                    <p class="description">Configuración</p>
                  </div>
                </a>
              </div>

              <vs-button
                type="border"
                color="#222222"
                size="small"
                class="rounded-button custom-sign-button mt-3"
                @click="closeSession"
                >Cerrar sesión
              </vs-button>
            </div>
          </div>
        </vs-dropdown-menu>
      </vs-dropdown>
    </vs-navbar>
  </header>
</template>

<script>
import { clearSession } from '@/axiosConfig'
import { SESSION_VARS } from '@/global/constants'
//import LangSelector from '../../../components/Shared/LangSelector'

export default {
  name: 'Navbar',
  components: {
  //LangSelector,
  },
  props: {
    topbarColor: {
      type: String,
      default: '#2962ff',
    },
    title: {
      type: String,
    },
    logo: {
      type: String,
    },
    // Obj for Userdropdown
    user: Object,
  },
  data: () => ({
    name: null,
    email: null,
    indexActive: 0,
    showToggle: false,
    searchvalue: '',
    // Data For User Dropdown
    users: [
      {
        img: '/user-1.jpg',
        // name: "Steave Jobs",
        email: 'varun@gmail.com',
        profile: 'Mi perfil',
        // dditem2: "My Balance",
        // dditem3: "Inbox",
        // dditem4: "Account Setting"
      },
    ],
  }),
  mounted() {
    const name = localStorage.getItem(SESSION_VARS.EMAIL)
    if (name) {
      this.name = name.substring(0, name.search('@')).toUpperCase()
    }
    this.email = localStorage.getItem(SESSION_VARS.EMAIL)
  },
  computed: {
    composedLink() {
      if (this.origin) {
        return `/public/view/profile`
      }
      return '#'
    },
  },
  created() {
    this.getOrigin()
  },
  methods: {
    getOrigin() {
      this.origin = location.origin
    },
    closeSession() {
      clearSession()
      location.href = '/view/login'
    },
    //This is for sidebar trigger in mobile
    activeSidebar() {
      this.$store.commit('IS_SIDEBAR_ACTIVE', true)
    },
    //This is for sidebar trigger in Desktop
    reduceSidebar() {
      this.$store.commit('TOGGLE_REDUCE_SIDEBAR', true)
      this.$store.dispatch('updateSidebarWidth', 'mini')
      this.showToggle = true
    },
    fullSidebar() {
      this.$store.commit('TOGGLE_REDUCE_SIDEBAR', false)
      this.$store.dispatch('updateSidebarWidth', 'default')
      this.showToggle = false
    },
  },
}
</script>
<style>
.icon-account {
  display: block;
  height: 24px;
}
</style>
